// Here we will create dark and light theme variables

export const lightTheme = {

    body: '#FFFFFF', // Background color
  bodyRgba: '255, 255, 255', // RGBA for body color
  text: '#000000', // Text color
  textRgba: '0, 0, 0' // RGBA for text col
}

export const DarkTheme = {

    body:"#000000",
    text:"#FCF6F4",
    fontFamily:"'Source Sans Pro', sans-serif",
    textRgba : "252, 246, 244",
    bodyRgba:"0,0,0",
}
